import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import classNames from 'classnames';
import { FragmentWithContent } from '../MultipleColumns';
import { PdfComponent } from '@distribute/frontend/ui/pdf-component';

export type PdfComponentNodeType = NodeViewProps['node'] & {
  attrs: {
    fileUrl: string;
    fileName: string;
  };
};

export type PdfComponentProps = Partial<NodeViewProps> & {
  selected: boolean;
  node: PdfComponentNodeType;
  className?: string;
};

export type Align = 'left' | 'center' | 'right';

export const PdfComponentView = ({
  node,
  editor,
  getPos,
  selected,
  className,
  updateAttributes,
}: PdfComponentProps) => {
  const { attrs } = node;
  const { fileUrl, fileName, origin } = attrs;

  const mediaWidth =
    node.attrs['data-media-width'] ??
    (node.content as FragmentWithContent)?.content?.[0]?.attrs.width;
  const mediaHeight =
    node.attrs['data-media-height'] ??
    (node.content as FragmentWithContent)?.content?.[0]?.attrs.height;
  const align = node.attrs['data-align'];

  const editorWidth = editor?.view.dom.getBoundingClientRect().width || 0;

  const updateSize = (width: number, height?: number) => {
    if (updateAttributes) {
      updateAttributes({
        'data-media-width': width,
        'data-media-height': height || mediaHeight,
      });
    }
  };

  const nodeViewClassName = classNames('!border-0', selected && 'selected');

  const handleElementClick = () => {
    if (editor && getPos) {
      const pos = getPos();
      editor.chain().setNodeSelection(pos).focus().run();
    }
  };

  return (
    <NodeViewWrapper className={nodeViewClassName}>
      <PdfComponent
        mediaHeight={mediaHeight}
        mediaWidth={mediaWidth}
        selected={selected}
        align={align}
        handleClick={handleElementClick}
        fileName={fileName}
        fileUrl={fileUrl}
        origin={origin}
        updateSize={updateSize}
        editorWidth={editorWidth}
      />
    </NodeViewWrapper>
  );
};
